export default "__VITE_ASSET__DsdZtSKm__"